export function getPatientId(patient_id, legacy_id) {
  let legacy = legacy_id ? `(Old: ${legacy_id})` : ''
  return patient_id ? `#${patient_id} ${legacy}` : ''
}
